module.exports = __webpack_public_path__ + "static/media/Semiconductors_Thumb_1.b1bf6f1c.jpg";